import React, { memo, useMemo } from 'react';
import { Collapse } from '../collapse';
import { getSizeBy } from '../../../src/styled/utils';
import { List } from '../list';
import { Item } from './item';
import styled from 'styled-components';
const Styled = styled(List) `
  padding-top: ${getSizeBy(2)};
  padding-bottom: ${({ $isLatest }) => ($isLatest ? '0px' : getSizeBy(2))};
`;
export const ChildItems = memo(({ isOpen, childItems, parent, toggle, onItemClick, checkSelection, isLatest }) => {
    const hasChildren = useMemo(() => !!childItems, [childItems]);
    return hasChildren ? (React.createElement(Collapse, { isOpen: isOpen, component: "li" },
        React.createElement(Styled, { "$isLatest": isLatest }, childItems === null || childItems === void 0 ? void 0 : childItems.map((childItem, index) => (React.createElement(Item, { key: childItem.id, item: childItem, parent: parent, toggle: toggle, onItemClick: onItemClick, checkSelection: checkSelection, isLatest: index === childItems.length - 1 })))))) : null;
});
